import Vue from 'vue'

const quote = (params) => {
  return Vue.prototype.$http.get('quote', { params })
}

export default {
  quote,
}
